import { render, staticRenderFns } from "./mailingListsView.vue?vue&type=template&id=199ee99e"
import script from "./mailingListsView.vue?vue&type=script&lang=js"
export * from "./mailingListsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports